import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["dialog"];

  open() {
    this.dialogTarget.hidden = false;
    requestAnimationFrame(() => this.dialogTarget.classList.add("confirm-dialog--open"));
    document.body.style.overflow = "hidden";
    // Lets bgm-wizard reset any unapplied pick back to the current track
    // and scroll it into view — the picker shouldn't remember a track the
    // user clicked but never applied.
    this.dispatch("opened");
  }

  close() {
    // Closing the modal doesn't unmount the bgm-row audio-players inside it —
    // without this, a track started before close keeps playing invisibly.
    document.dispatchEvent(new CustomEvent("audio-player:pause-all", { detail: { except: null } }));
    this.dialogTarget.classList.remove("confirm-dialog--open");
    document.body.style.overflow = "";
    const panel = this.dialogTarget.querySelector(".confirm-dialog__panel");
    const duration = panel ? parseFloat(getComputedStyle(panel).transitionDuration) * 1000 : 0;
    if (duration > 0) {
      panel.addEventListener("transitionend", () => { this.dialogTarget.hidden = true; }, { once: true });
    } else {
      this.dialogTarget.hidden = true;
    }
  }

  keydown(e) {
    if (this.dialogTarget.hidden) return;
    if (e.key === "Escape") this.close();
  }
}
